import React from "react";
import styled from "styled-components";
import { useTranslate } from "@tolgee/react";
import { ReactComponent as Translate } from "../../Assets/iconsv2/sidebar/Translate.svg";
import SettingsElement from "../Settings/SettingsElement";
import { TOOLS_TRANSLATE, TOOLS_PRESENTATIONS, TOOLS_VIDEO_TRANSLATION, TOOLS_CONVERSATION, TOOLS_LIVE_FEED } from "../../Constants/constantValues";
import { ConversationIcon, LiveFeedIcon } from "./ToolIcons";

const ToolsMenuList = ({ displayCategory, setDisplayCategory }) => {
  const { t } = useTranslate();
  return (
    <ToolsMenuListContainer>
      <Header>
        <HeaderTitle>{t("tools_menu.header")}</HeaderTitle>
      </Header>
      <Content>
        <Group>
          <GroupContentWrapper>
            
            <SettingsElement
              text={t("tools_menu.translate")}
              icon={<Translate />}
              onClick={() => setDisplayCategory(TOOLS_TRANSLATE)}
              selected={displayCategory === TOOLS_TRANSLATE}
            />

            <SettingsElement
              text={t("tools_menu.conversation")}
              icon={<ConversationIcon />}
              onClick={() => setDisplayCategory(TOOLS_CONVERSATION)}
              selected={displayCategory === TOOLS_CONVERSATION}
            />

            <SettingsElement
              text={t("tools_menu.live_feed") || "Live feed"}
              icon={<LiveFeedIcon />}
              onClick={() => setDisplayCategory(TOOLS_LIVE_FEED)}
              selected={displayCategory === TOOLS_LIVE_FEED}
            />

            <SettingsElement
              text={t("presentation_tool.title")}
              icon={<PresentationIcon />}
              onClick={() => setDisplayCategory(TOOLS_PRESENTATIONS)}
              selected={displayCategory === TOOLS_PRESENTATIONS}
            />

            <SettingsElement
              text={t("video_tool.title")}
              icon={<VideoIcon />}
              onClick={() => setDisplayCategory(TOOLS_VIDEO_TRANSLATION)}
              selected={displayCategory === TOOLS_VIDEO_TRANSLATION}
            />

          </GroupContentWrapper>
        </Group>
      </Content>
    </ToolsMenuListContainer>
  );
};

export default ToolsMenuList;


const VideoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="15" height="16" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 9l5-3v12l-5-3V9z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PresentationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3h20v14H2V3zm10 14v4m-4 0h8M8 10l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ToolsMenuListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  border-right: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  max-width: 420px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 23px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;

const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  overflow: hidden;
`;